var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('PageHeader',{attrs:{"breadcrumbLinks":_vm.breadcrumbLinks,"title":"Mais","subtitle":_vm.$t('generic-str.event-log')}}),_c('div',{staticClass:"page-content container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('LogList')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }